import { useMemo } from 'react'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import { useSchemeContext } from './useSchemeContext'

interface UseSchemeTextFieldsResult {
  text: NonNullable<DesignPersonalizationContext['text']>
  hasText: boolean
}

export const useSchemeText = (schemeId: string): UseSchemeTextFieldsResult => {
  const { contextData } = useSchemeContext(schemeId)

  const text = useMemo(() => contextData?.text ?? [], [contextData?.text])
  const hasText = useMemo(() => !!Object.values(text).some(({ textField }) => textField.text !== ''), [text])

  return { text, hasText }
}
